import { Component } from "react";
import bcrypt from 'bcryptjs';

export class Auth extends Component {

    static async Login(password) {
        // Password
        const hashedPassword = '$2a$12$anm/OQUZNSchJZLswk8MOuTc8ItIVFToZRVl/fSchAAb./ptk4ubK';

        // Compare the hashed user input with the stored hash
        const result = await bcrypt.compare(password, hashedPassword);
        if (result) {
            console.log("login successful");
            const now = new Date().getTime();
            const expiry = now + (90 * 24 * 60 * 60 * 1000);
            const jsonString = JSON.stringify({ expires_in: expiry });
            localStorage.setItem('loginToken', jsonString);
            return true;
        } else {
            console.error("Bad Password");
            return false;
        }
    }

    static logout() {
        console.log("Log out")
        localStorage.removeItem('loginToken');
        window.location.reload(false);
    }

    static getUserToken() {
        const storage = JSON.parse(localStorage.getItem('loginToken'));
        if (storage) {
            if (storage.expires_in > Date.now()) {
                return true;
            } else {
                console.error("Token Expired:");
                this.logout();
                return false;
            }
        }
    }
}

export default Auth